import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';

interface H5TabNavProps {
    navList: any    // 导航列表数据
    navClick: Function  // 导航点击事件
    boxWidth?: any   // 导航所占宽度，默认100%
    zIndex?: number // 导航显示层级，默认为10 
    boxStylesData?: any // 导航最外层父级盒子自定义样式
    isAlignLeft?: any // 导航是否居左，默认为false居中，并选项平分总宽度，如果超过4个选项或者isAlignLeft为true就居左对齐，间距为64px
    currentIndex?: number  // 当前点击的索引，默认为0，第一个被选中
    showAlias?: any // 是否显示别名
    showRightCornerNum?: boolean    // 是否显示右上角数量
}

@inject('app', 'site', 'user')
@observer
class H5TabNav extends React.Component<H5TabNavProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        let { navList, currentIndex = 0, boxStylesData, isAlignLeft, showAlias, showRightCornerNum = false } = this.props
        let navLength = navList?.length; // 数组长度
        return <div className={styles.navOutBox}>
            <div className={styles.navBox} style={boxStylesData}>
                <div className={classNames(styles.navList, (isAlignLeft || navLength > 4) ? styles.navBoxLeft : '')}>
                    {navList?.map((item:any, index:any) => {
                        return <div key={index} className={classNames(styles.navItem, currentIndex == index ? styles.navActive : '')} onClick={() => {
                            this.props.navClick && this.props.navClick(item, index)
                        }}>
                            <div className={styles.name}>{showAlias && item.associatedAlias ? item.associatedAlias : item.name}</div>
                            {(showRightCornerNum && item.num > 0) && <div className={styles.num}>{item.num}</div>}
                        </div>
                    })}
                </div>
            </div>
        </div>;
        
    }
}

export default H5TabNav;